import { FaSignOutAlt } from "react-icons/fa";
import { IoIosBusiness } from "react-icons/io";
import { MdCategory, MdArticle, MdNewReleases, MdChecklist } from "react-icons/md";

export const NAV_ITEMS = [
    {
        itemName: "Home",
        page: '/home'
    },
    {
        itemName: "Tenants",
        dropDownItems: [
            {
                id: 'list_sales_orders',
                icon: IoIosBusiness,
                text: 'Companies',
                modal: false,
                page: '/companies'
            },
        ]
    },
    {
        itemName: "Help Content",
        dropDownItems: [
            {
                id: 'list_help_categories',
                icon: MdCategory,
                text: 'Categories',
                modal: false,
                page: '/help-categories'
            },
            {
                id: 'list_help_articles',
                icon: MdArticle,
                text: 'Articles',
                modal: false,
                page: '/help-articles'
            },
            {
                id: 'list_help_updates',
                icon: MdNewReleases,
                text: "What's New",
                modal: false,
                page: '/help-updates'
            },
            {
                id: 'list_help_onboarding_steps',
                icon: MdChecklist,
                text: 'Getting Started Steps',
                modal: false,
                page: '/help-onboarding-steps'
            },
        ]
    },
]

export const SETTING_NOTFICATION_BAR = [
    {
        itemName: "Settings",
        dropDownItems: [
            {
                id: 'logout',
                icon: FaSignOutAlt,
                text: 'logout',
                modal: false,
                page: '/logout',
                breakpoint: true,
                inverted: true
            },
        ]
    },
]



